import React, { useState, lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import promotionIcon from '../static/img/promotion-icon.png';
import promoImg1 from '../static/img/slide-1.jpg';

// Lazy load the PromotionModal
const PromotionModal = lazy(() => import('../modal/modal_promotion.js')); // Adjust the path as needed

// Дані про промоції
const promotions = [
  {
    imageSrc: 'https://storage.googleapis.com/camasy-images/casino/pragmatic__play__live__63d3ec69db799.png',
    title: 'Bonus intasca un amico',
    description: [
      'I nostri giochi esclusivi includono intrattenimento entusiasmante in una varietà di generi e formati.',
      'Slot con simboli 1win unici che fungono da Wild, Scatter o moltiplicatori alti.',
      'Decolla con 1win per quote elevate senza precedenti nei crash giochi personalizzati!',
    ],
  },
  {
    imageSrc: 'https://1151707530.rsc.cdn77.org/casinoimages/wild-shark_amatic.jpg',
    title: 'Wild Shark Promotion',
    description: [
      'Vivi un\'esperienza di gioco indimenticabile con Wild Shark.',
      'Grande opportunità per vincere premi esclusivi.',
    ],
  },
  {
    imageSrc: '/assets/img/slide-1.jpg',
    title: 'Bonus intasca un amico',
    description: [
      'Descrizione третьої промоції. Додається опис пропозиції та бонусів.',
    ],
  },
  {
    imageSrc: 'https://imgproxy.v1.bundlecdn.com/unsafe/casino_home_2x/plain/https://v1.bundlecdn.com/casino-images/pragmatic/0e2d11b9-786d-4e45-8265-542c38fc3575.jpg@png',
    title: 'Pragmatic Bonus',
    description: [
      'Пропозиція для нових гравців з великими виграшами.',
      'Використовуйте бонуси для максимальних виграшів.',
    ],
  },
];

// Компонент для відображення кожної промоції
const PromotionCard = ({ imageSrc, title, onClick }) => (
  <div className="HomeSectionCasinoGames_game" onClick={onClick}>
    <div className="CasinoGameCard_root">
      <div className="CasinoGamePreview_root">
        <div className="CasinoGamePreview_gradient"></div>
        <img
          className="ResponsivePicture_img CasinoGamePreview_image"
          src={imageSrc}
          alt={title}
          loading="lazy"
        />
      </div>
      <div className="title-boxPromotions">
        <a href="#">{title}</a>
      </div>
    </div>
  </div>
);

const PromotionSection = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedPromotion, setSelectedPromotion] = useState(null);
  const {t} = useTranslation();

  // Open modal only for the first promotion
  const handleOpenModal = (promo, index) => {
    if (index === 0) { // Open modal only if it's the first promotion
      setSelectedPromotion(promo);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPromotion(null);
  };

  return (
    <>
      <div className="body main-layout-item promotion_box">
        <div className="Home_root">
          <div className="Home_games">
            <div className="Home_header">
              <a href="#" className="HomeSection_header">
                <img alt="Promotion" src="/assets/img/promotion-icon.png" className="HomeSection_icon" />
                <div className="HomeSection_label">{t('Promotions')}</div>
                <div className="HomeSection_right">
                  <div className="HomeSection_headerLink">{t('All')}</div>
                  <div className="HomeSection_caption">10 {t('Promotions')}</div>
                </div>
              </a>
            </div>
            <div className="HomeSectionCasinoGames_list promotion_size_scroll">
              {promotions.map((promo, index) => (
                <PromotionCard
                  key={index}
                  imageSrc={promo.imageSrc}
                  title={promo.title}
                  onClick={() => handleOpenModal(promo, index)} // Pass index to handle only first promotion
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Lazy-loaded Promotion Modal */}
      {showModal && selectedPromotion && (
        <Suspense fallback={<div>{t('loading')}...</div>}>
          <PromotionModal
            show={showModal}
            handleClose={handleCloseModal}
            title={selectedPromotion.title}
            imageSrc={selectedPromotion.imageSrc}
            description={selectedPromotion.description}
          />
        </Suspense>
      )}
    </>
    
  );
};

export default PromotionSection;
